<template>
  <b-form
    id="new-video-request-form"
    class="new-video-request-form d-flex flex-column"
    @submit.prevent="onSubmit"
  >
    <b-row>
      <b-col cols="12">
        <b-form-group
          id="new-video-request-form-group-1"
          label="Invitation Message"
          label-for="invitation-message-input"
        >
          <b-form-textarea
            id="invitation-message-input"
            v-model="form.invitationMessage"
            placeholder="Enter invitation message..."
            :disabled="sendingRequest"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6">
        <b-form-group id="new-video-request-form-group-2">
          <b-form-checkbox
            v-model="form.enableVideo"
            switch
            :disabled="sendingRequest"
          >Enable my video</b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6">
        <b-form-group id="new-video-request-form-group-3">
          <b-form-checkbox
            v-model="form.enableAudio"
            switch
            :disabled="sendingRequest"
          >Enable my audio</b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6">
        <b-form-group id="new-video-request-form-group-4">
          <b-form-checkbox
            v-model="form.blurVideo"
            switch
            :disabled="sendingRequest"
          >Blur recipient video</b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6">
        <b-form-group id="new-video-request-form-group-5">
          <b-form-checkbox
            v-model="form.recordSession"
            switch
            :disabled="sendingRequest"
          >Record session</b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6">
        <b-form-group id="new-video-request-form-group-6">
          <b-form-checkbox
            v-model="form.enableTranscription"
            switch
            :disabled="sendingRequest"
          >Enable transcription</b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-button
      type="submit"
      variant="info"
      pill
      class="ml-auto"
      style="width: 200px"
      :disabled="sendingRequest"
    >Send</b-button>
  </b-form>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";
export default {
  name: "NewVideoRequestForm",
  props: {
    conversationId: String,
    recipientId: String,
    recipientLabel: String,
    recipientLanguage: String,
  },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["currentAgency", "agencySettings"]),
    ...mapGetters("conversations", ["currentConversation"]),
    ...mapGetters("persist", ["userVideoRequestPersisted"]),
  },
  created() {
    //initiate form fields
    const { enableAudio, enableVideo, blurVideo, enableTranscription } = this.userVideoRequestPersisted;
    const invitationMessage = this.currentAgency.settings.videoRequestExplainMsg;
    const recordSession = this.currentAgency.settings.enableVideoRecording == 'true';
    this.form = {
      invitationMessage,
      enableVideo,
      enableAudio,
      blurVideo,
      recordSession,
      enableTranscription,
    };
  },
  data() {
    return {
      sendingRequest: false,
      form: {
        invitationMessage: '',
        enableVideo: false,
        enableAudio: false,
        blurVideo: false,
        recordSession: false,
        enableTranscription: false,
      },
    };
  },
  methods: {
    async onSubmit() {
      this.sendingRequest = true;
      this.$store.commit("persist/setUserVideoRequestPersisted", {
        enableVideo: this.form.enableVideo,
        enableAudio: this.form.enableAudio,
        blurVideo: this.form.blurVideo,
        enableTranscription: this.form.enableTranscription,
      });

      // Create a new video room
      let roomId;
      try {
        const payload = {
          conversation_id: this.conversationId,
          record: this.form.recordSession,
          transcription: this.form.enableTranscription,
        }
        const resp = await this.$ConveyApi.videoApi.createVideoRoom({ payload })
        roomId = resp.data.data.room_id;
        this.$store.commit("video/upsertVideoRoom", resp.data.data);
        this.$store.commit("video/setVideoRoomCreated", { status: true, conversationId: this.conversationId });
      } catch (e) {
        this.$toastr("error", "Error encountered while generating a new video room request. Please try again.");
        console.log(e.message);
        this.sendingRequest = false;
      }

      if (!this.sendingRequest) return;
      
      // Generate a magic token for recipient access
      try {
        const payload = {
          service_type: "createVideoRoomToken",
          token_data: {
            room_id: roomId,
            recipient: this.recipientLabel,
            agency_logo: this.$cookie.get("x-agency-logo"),
            conversation_id: this.conversationId,
            agency_id: this.currentAgency.agency_id,
            enableChat: 'enable',
            enableTranscription: this.form.enableTranscription,
          },
          send_invitation: true,
          invitation_message: this.form.invitationMessage,
          recipient_id: this.recipientId
        };
        await this.$ConveyApi.tokensApi.createMagicToken({ payload });
        this.$toastr("success", "Video request sent");
      } catch (e) {
        this.$toastr("error", "Encountered an error creating a video room request. Please try again.");
        console.log(e.message);
      }
      this.sendingRequest = false;
      EventBus.$emit("close-modal");
    },
  },
};
</script>

<style lang="scss">
.new-video-request-form {
  .custom-switch {
    label:after {
      top: 0.25rem !important;
    }
  }
}
</style>
